// import { useEffect, useState } from "react";
// import { SketchPicker } from "react-color";
// import { useSelector } from "react-redux";
// import { StoreProptypes } from "../../PropTypes/StoreProptypes";
// import { Form } from "react-bootstrap";
// import { t } from "i18next";

// interface PropTypes {
//     setChangeWidgetIconColor: Function, // function to set widget icon color
//     changeWidgetIconColor: string, // function to set widget icon color
//     isWidgetIconColor: boolean,
//     setIsWidgetIconColor: Function,
// }

// // component to set widget icon color
// const WidgetIconColor = (props: PropTypes) => {

//     // Props
//     const { setChangeWidgetIconColor, changeWidgetIconColor, isWidgetIconColor, setIsWidgetIconColor } = props;

//     // Redux Data
//     const { currentWebsite } = useSelector((store: StoreProptypes) => store);

//     // Stets
//     const [widgetColor, setWidgetColor] = useState<string>('#420083');

    
//     useEffect(() => {
//         // check if change widget icon color is available
//         if (changeWidgetIconColor) {
//             setWidgetColor(changeWidgetIconColor);
//         } else {
//             setWidgetColor('#420083')
//         }
//     }, [changeWidgetIconColor]);

//     // Set current widget icon type
//     useEffect(() => {
//         if (currentWebsite) {
//             // check if widget color is available
//             if (currentWebsite.widget_color_code) {
//                 setChangeWidgetIconColor(currentWebsite.widget_color_code);
//             } else {
//                 setChangeWidgetIconColor('#420083');
//             }
//         }
//     }, [currentWebsite]);

//      useEffect(() => {
//         // check if change widget icon color is available
//         if (isWidgetIconColor) {
//             setIsWidgetIconColor(isWidgetIconColor ? true : false);
//         } else {
//             setIsWidgetIconColor(false)
//         }
//     }, [isWidgetIconColor]);

//     return (
//         <>

//          <div className="d-flex flex-column gap-4">
//                 <Form.Check
//                     type="switch"
//                     className="aioa_dashboard-switch"
//                     id="custom-switch-size"
//                     label={<span style={{ fontSize: "0.90rem" }}>
//                         {t('Change Widget color')}
//                     </span>}
//                     checked={isWidgetIconColor}
//                     onChange={(e) => setIsWidgetIconColor(!isWidgetIconColor)}
//                 />
//                 {isWidgetIconColor && (
//                     <div className="border-top pt-4">
//                        <SketchPicker
//                             disableAlpha={true}
//                             color={widgetColor}
//                             onChange={(colorObject, e) => {
//                                 setChangeWidgetIconColor(colorObject.hex);
//                             }}
//                         />
//                     </div>
//                 )}
//             </div>
            
//         </>
//     )
// }

// export default WidgetIconColor;

import { useEffect, useState } from "react";
import { SketchPicker } from "react-color";
import { useSelector } from "react-redux";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import { t } from "i18next";

interface PropTypes {
    setChangeWidgetIconColor: Function,
    changeWidgetIconColor: string,
}

// Default color options
const DEFAULT_COLORS = [
    '#420083', // Purple
    '#FF4444', // Red
    '#44FF44', // Green
    '#4444FF', // Blue
    '#FFA500', // Orange
];

const WidgetIconColor = (props: PropTypes) => {

    const { setChangeWidgetIconColor, changeWidgetIconColor } = props;
    const { currentWebsite } = useSelector((store: StoreProptypes) => store);
    const [widgetColor, setWidgetColor] = useState<string>('#420083');
    const [showColorPicker, setShowColorPicker] = useState<boolean>(false);

    useEffect(() => {
        if (changeWidgetIconColor) {
            setWidgetColor(changeWidgetIconColor);
            // Check if current color is in default colors, if not, show color picker
            if (!DEFAULT_COLORS.includes(changeWidgetIconColor)) {
                setShowColorPicker(true);
            }
        } else {
            setWidgetColor('#420083');
            setShowColorPicker(false);
        }
    }, [changeWidgetIconColor]);

    useEffect(() => {
        if (currentWebsite) {
            if (currentWebsite.widget_color_code) {
                setChangeWidgetIconColor(currentWebsite.widget_color_code);
            } else {
                setChangeWidgetIconColor('#420083');
            }
        }
    }, [currentWebsite]);

    const handleColorSelect = (color: string) => {
        setWidgetColor(color);
        setChangeWidgetIconColor(color);
        setShowColorPicker(false);
    };

    const handleCustomColor = () => {
        setShowColorPicker(true);
    };

    return (
        <div className="d-flex flex-column gap-4">
            {/* Color Swatches */}
            <div>
                <label style={{ fontSize: "0.85rem", marginBottom: "10px", display: "block", color: "#666" }}>
                    {t('Widget Color')}
                </label>
                <div style={{ display: "flex", gap: "12px", alignItems: "center", flexWrap: "wrap" }}>
                    {DEFAULT_COLORS.map((color) => (
                        <div
                            key={color}
                            onClick={() => handleColorSelect(color)}
                            style={{
                                width: "35px",
                                height: "35px",
                                borderRadius: "50%",
                                backgroundColor: color,
                                cursor: "pointer",
                                border: widgetColor === color ? "3px solid #000" : "3px solid transparent",
                                boxShadow: widgetColor === color ? "0 0 0 2px #fff, 0 0 0 4px #000" : "none",
                                transition: "all 0.2s ease"
                            }}
                        />
                    ))}
                    
                    {/* Custom Color Button */}
                    <div
                        onClick={handleCustomColor}
                        style={{
                            width: "35px",
                            height: "35px",
                            borderRadius: "50%",
                            backgroundColor: "#f0f0f0",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: showColorPicker ? "2px solid #420083" : "2px solid #ddd",
                            transition: "all 0.2s ease"
                        }}
                        title={t('Custom Color')}
                    >
                        <span style={{ fontSize: "18px", color: "#666" }}>✏️</span>
                    </div>
                </div>
            </div>

            {/* Custom Color Picker (shown when pen icon is clicked) */}
            {showColorPicker && (
                <div className="mt-3" style={{ 
                    border: "1px solid #e0e0e0", 
                    borderRadius: "8px", 
                    padding: "15px",
                    backgroundColor: "#fff"
                }}>
                    <div style={{ 
                        display: "flex", 
                        justifyContent: "space-between", 
                        alignItems: "center", 
                        marginBottom: "15px" 
                    }}>
                        <label style={{ fontSize: "0.85rem", color: "#666" }}>
                            {t('Custom Color Picker')}
                        </label>
                        <button
                            onClick={() => setShowColorPicker(false)}
                            style={{
                                background: "none",
                                border: "none",
                                fontSize: "20px",
                                cursor: "pointer",
                                color: "#999"
                            }}
                        >
                            ×
                        </button>
                    </div>
                    <SketchPicker
                        disableAlpha={true}
                        color={widgetColor}
                        onChange={(colorObject) => {
                            setWidgetColor(colorObject.hex);
                            setChangeWidgetIconColor(colorObject.hex);
                        }}
                    />
                </div>
            )}

            {/* Show selected color info */}
            {!showColorPicker && widgetColor && !DEFAULT_COLORS.includes(widgetColor) && (
                <div className="mt-2" style={{ 
                    display: "flex", 
                    alignItems: "center", 
                    gap: "10px",
                    padding: "10px",
                    backgroundColor: "#f9f9f9",
                    borderRadius: "6px"
                }}>
                    <div style={{
                        width: "30px",
                        height: "30px",
                        borderRadius: "50%",
                        backgroundColor: widgetColor,
                        border: "1px solid #ddd"
                    }} />
                    <span style={{ fontSize: "0.85rem", color: "#666" }}>
                        {t('Current Color')}: {widgetColor}
                    </span>
                </div>
            )}
        </div>
    )
}

export default WidgetIconColor;